import { instance as axios } from "./baseUrl";

// TODO: Brancher sur les vrais endpoints back quand ils seront prêts
export const priceRcApi = () =>
  axios.post("subscription/rc/price");

const toISODateTime = (dateStr) => {
  if (!dateStr) return null;
  if (dateStr.includes('T')) return dateStr;
  return `${dateStr}T00:00:00.000Z`;
};

export const subscriptionRcApi = ({ startDate, endDate, contractReference, forceSubscription = false }) =>
  axios.post("subscription/rc/session", {
    startDate: toISODateTime(startDate),
    endDate: toISODateTime(endDate),
    contractReference,
    ...(forceSubscription && { forceSubscription: true }),
  });

export const initSignatureRc = (contractReference) =>
  axios.post("subscription/rc/contract/init-signature", { contractReference });

export const attestationRcContract = (contractReference) =>
  axios.post("subscription/rc/contract/attestation", { contractReference });
